// Дефолтные данные в data которые должны быть почти на всех страницах
// Варианты нотификации {
    DEFAULT: "default"
    ERROR: "error"
    INFO: "info"
    SUCCESS: "success"
    WARNING: "warning"
//}

import { TYPE } from "vue-toastification";

export const defaultDataItems = {
    components: {
    },
    data() {
        return {
            items: {
                data: [],
                headers: [],
                actionAllows: [],
                current_page: 1,
                per_page: 25,
                total: 0,
            },
            dataOverlay: true
        }
    },
    mounted() {
    },
    methods: {
        makeToast(typeNotification, message = 'Успешно!', timeout = 5000) {
            let variant;
            switch (typeNotification) {
                case 'danger':
                    variant = 'ERROR'
                    break;
                case 'success':
                    variant = 'SUCCESS'
                    break;
                case 'info':
                    variant = 'INFO'
                    break;
            }

            this.$toast(message, {
                type: TYPE[variant],
                position: "top-right",
                timeout: timeout,
                closeOnClick: true,
                pauseOnFocusLoss: false,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 1.01,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: "button",
                icon: true,
                rtl: false
            });
        }
    }
}
